import { Injectable } from '@angular/core';
import { DynamicKeyValue } from '../../utils/types.utils';
import { WindowRefService } from '../../utils/window-ref.service';

@Injectable()
export class HeightEqualizerService {
	private groups: DynamicKeyValue<any[]> = {};

	public constructor(private windowRef: WindowRefService) {}

	public addToGroup(group: string, element: any): void {
		this.groups[group] = this.groups[group] || [];
		this.groups[group].push(element);
	}

	public removeFromGroup(group: string, element: any): void {
		if (!this.groups[group]) return;
		this.groups[group] = this.groups[group].filter(e => e !== element);

		// on vient de supprimer le dernier element du group
		if (!this.groups[group].length) {
			delete this.groups[group];
		}
	}

	public ensureHeightForGroup(group: string): void {
		if (!this.groups[group]) return;
		this.ensureEqualHeight(this.groups[group]);
	}

	public ensureEqualHeight(elements: any[]): void {
		if (!elements.length) return;
		elements.forEach(child => (child.style.height = 'auto'));
		const tallest = elements.reduce((prev, curr) => {
			if (!prev) return curr;
			if (this.getHeight(curr) > this.getHeight(prev)) return curr;
			return prev;
		}, null);
		const maxHeight = this.getHeight(tallest);
		elements.forEach(child => (child.style.height = maxHeight + 'px'));
	}

	private getHeight(element: any): void {
		let h;
		let initialStyle;
		const window = this.windowRef.nativeWindow;

		if (element.currentStyle) {
			// IE
			initialStyle = window.getComputedStyle(element);
			h =
				parseFloat(initialStyle.getPropertyValue('height')) +
				parseFloat(initialStyle.getPropertyValue('padding-top')) +
				parseFloat(initialStyle.getPropertyValue('padding-bottom'));
		} else {
			initialStyle = window.getComputedStyle(element);
			h = parseFloat(initialStyle.getPropertyValue('height'));
		}
		return h;
	}
}
